






















































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import PriceSnapshotFormDialog from '@/components/snapshot/PriceSnapshotFormDialog.vue';
import ConfirmDialog from '@/components/core/ConfirmDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';

import { ErrorManager } from '@/models/error';
import { IPriceSnapshot, PriceSnapshot } from '@/models';

import { IFetchItemsActionPayload } from '@/store/item';
import auth from '@/mixins/auth';
import ALPage from '@/components/core/Page/ALPage.vue';

export default auth.extend({
  components: {
    PriceSnapshotFormDialog,
    ConfirmDialog,
    ErrorAlert,
    ALPage
  },

  data() {
    return {
      search: '',
      loading: false,

      headers: [
        { text: 'Label', value: 'description' },
        { text: 'Created At', value: 'created_at' },
        { text: 'Created By', value: 'owner' },
        { text: '', value: 'actions', sortable: false }
      ],

      errorMessage: '',
      detailErrorMessage: '',

      options: {
        showFirstLastPage: true,
        itemsPerPageOptions: [100]
      },
      page: 1,

      actionLoading: false
    };
  },

  computed: {
    ...mapGetters({
      priceSnapshots: 'priceSnapshot/getPriceSnapshots',
      priceSnapshotCount: 'priceSnapshot/getPriceSnapshotCount'
    })
  },

  watch: {
    search(newSearch: string, prevSearch: string) {
      if (newSearch !== prevSearch) {
        this.page = 1; //called fetchdata
        this.fetchPriceSnapshotResults(this.page, newSearch);
      }
    },

    page: {
      handler(val) {
        this.fetchPriceSnapshotResults(val);
      }
    }
  },

  mounted() {
    this.fetchPriceSnapshotResults(this.page);
  },

  methods: {
    ...mapActions({
      fetchPriceSnapshots: 'priceSnapshot/fetchPriceSnapshots',
      deletePriceSnapshot: 'priceSnapshot/deletePriceSnapshot'
    }),

    goToItemWithSnapshot(item: IPriceSnapshot) {
      this.$router.push({
        name: 'item-list',
        query: { snapshot: item.id?.toString() }
      });
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    createPriceSnapshot() {
      const itemSnaphotFormDialog = this.$refs
        .PriceSnapshotFormDialog as InstanceType<
        typeof PriceSnapshotFormDialog
      >;

      itemSnaphotFormDialog.open();
    },

    updatePriceSnapshot(item: PriceSnapshot) {
      const itemSnaphotFormDialog = this.$refs
        .PriceSnapshotFormDialog as InstanceType<
        typeof PriceSnapshotFormDialog
      >;

      itemSnaphotFormDialog.open(item, true);
    },

    fetchPriceSnapshotResults(page: number, search?: string) {
      const params = { page, search } as IFetchItemsActionPayload;

      this.loading = true;
      this.fetchPriceSnapshots(params)
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.loading = false));
    },

    async deleteSnapshotRecord(item: PriceSnapshot) {
      const confirm = (this as any).$refs.confirm;
      if (
        await confirm.open(
          'Delete Pricing Snapshot',
          {},
          `<span style="line-height: 19px;">Are you sure you want to delete snapshot <strong class="text--primary" style="word-break: normal">${item.id}</strong>? <br /> This action cannot be undone.</span>`
        )
      ) {
        this.loading = true;
        this.deletePriceSnapshot(item.id)
          .catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => (this.loading = false));
      }
    }
  }
});
